import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StationBlockAlertSelectRequest } from "./station-block-alert-select-request";
import { StationBlockAlertAssignRequest } from "./station-block-alert-assign-request";
import { StationBlockAlertInsertRequest } from "./station-block-alert-insert-request";
import { StationBlockAlertUpdateRequest } from "./station-block-alert-update-request";
import { StationBlockAlertAssignmentToggleRequest } from "./station-block-alert-assignment-toggle-request";

@Injectable()
export class DataService_BlockListSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	StationBlockAlertSelectList(parms: StationBlockAlertSelectRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertInsert(parms: StationBlockAlertInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertUpdate(parms: StationBlockAlertUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertToggle(StationBlockAlertID: number, Active: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertToggle?StationBlockAlertID=" + StationBlockAlertID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertDelete(StationBlockAlertID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertDelete?StationBlockAlertID=" + StationBlockAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertAssign(parms: StationBlockAlertAssignRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertAssign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertUnassign(parms: StationBlockAlertAssignRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertUnassign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertAssignmentsSelectList(StationBlockAlertID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertAssignmentsSelectList?StationBlockAlertID=" + StationBlockAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SBAInsertHomeroomSelectList(SchoolID: number, StationBlockAlertID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SBAInsertHomeroomSelectList?SchoolID=" + SchoolID + "&StationBlockAlertID=" + StationBlockAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SBAInsertGroupSelectList(SchoolID: number, StationBlockAlertID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SBAInsertGroupSelectList?SchoolID=" + SchoolID + "&StationBlockAlertID=" + StationBlockAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SBAInsertPersonSelectList(SchoolID: number, StationBlockAlertID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SBAInsertPersonSelectList?SchoolID=" + SchoolID + "&StationBlockAlertID=" + StationBlockAlertID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationBlockAlertAssignmentToggle(parms: StationBlockAlertAssignmentToggleRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationBlockAlertAssignmentToggle";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
